module.exports = __webpack_public_path__ + "img/Weapon_292.f4379001.png";